import { SET_BUCKET_DOMAIN, SET_BUCKET_DOMAIN_TOKEN } from "./mutationTypes";

export default {
  update_operation_list(state, payload) {
    state.operationList = payload;
  },
  update_permission_list(state, payload) {
    state.permissionList = payload;
  },
  setKeepAlive(state, payload) {
    state.keepAliveComponents = payload;
  },
  updateLoginData(state, payload) {
    state.loginData = payload;
  },
  [SET_BUCKET_DOMAIN](state, payload) {
    state.imgDomain = payload;
  },
  [SET_BUCKET_DOMAIN_TOKEN](state, payload) {
    state.bucket_domain_token = payload;
  },
  SET_ROUTER_ACTIVE(state, payload) {
    state.activeIndex = payload;
  },
  SET_AREA_LIST(state, payload) {
    state.areaList = payload;
  },
  SET_CODE_TEXT(state, payload) {
    state.areaMap = payload;
  },
};
